export function maskEmailAddress(emailAddress = ''){
  if(!emailAddress) return emailAddress;
  const parts = emailAddress.split('@');
  const name = parts[0];
  return `${name[0]}...${name[name.length-1]}@${parts[1]}`;
}
